import React, { Component } from "react";
import { CircularProgress, Box, Typography } from "@mui/material";
import Api from "../../services/api";
import { PapiroConsole } from "../../utils/papiroConsole";

class FeedbackProviderRedirect extends Component {
  componentDidMount() {
    this.registerClickAndRedirect();
  }

  buildFeedbackUrl = () => {
    const { lang, token, type, stars, fqa } = this.props.match.params;
    PapiroConsole.log("=== FeedbackProviderRedirect - buildFeedbackUrl - params ===");
    PapiroConsole.log({ lang, token, type, stars, fqa });

    const rawSegments = [lang, "feedback", token, type, stars, fqa];
    PapiroConsole.log("=== FeedbackProviderRedirect - buildFeedbackUrl - rawSegments ===");
    PapiroConsole.log(rawSegments);

    const segments = rawSegments.filter(Boolean);
    PapiroConsole.log("=== FeedbackProviderRedirect - buildFeedbackUrl - segments ===");
    PapiroConsole.log(segments);

    const queryString = this.props.location.search || "";
    PapiroConsole.log("=== FeedbackProviderRedirect - buildFeedbackUrl - queryString ===");
    PapiroConsole.log(queryString);

    const feedbackUrl = `/${segments.join("/")}${queryString}`;
    PapiroConsole.log("=== FeedbackProviderRedirect - buildFeedbackUrl - feedbackUrl ===");
    PapiroConsole.log(feedbackUrl);

    return feedbackUrl;
  };

  registerClickAndRedirect = async () => {
    const { token } = this.props.match.params;
    const feedbackUrl = this.buildFeedbackUrl();

    try {
      await Api.post("/feedback/provider-link-click", {
        accesstoken: token
      });
    } catch (error) {
      // O redirecionamento nao pode ser bloqueado pela contagem do clique.
    } finally {
      this.props.history.replace(feedbackUrl);
    }
  };

  render() {
    return (
      <Box
        minHeight="100vh"
        display="flex"
        alignItems="center"
        justifyContent="center"
        flexDirection="column"
        gap={2}
      >
        <CircularProgress />
        <Typography variant="body2">Redirecionando para a pesquisa...</Typography>
      </Box>
    );
  }
}

export default FeedbackProviderRedirect;
